import { isImmutable } from 'immutable';

import { isObject } from '../isObject';
import { getSize } from './getSize';
import { reduce } from './reduce';

export function areEqual(...comparers) {
  function compare(x, y) {
    if (typeof x !== typeof y) {
      return false;
    }

    if (isImmutable(x)) {
      return isImmutable(y) && x.equals(y);
    } else if (isImmutable(y)) {
      return false;
    }

    if (Array.isArray(x)) {
      return Array.isArray(y) && getSize(x) === getSize(y) && areEqual(x, y);
    } else if (Array.isArray(y)) {
      return false;
    }

    if (isObject(x)) {
      return isObject(y) && getSize(x) === getSize(y) && areEqual(x, y);
    } else if (isObject(y)) {
      return false;
    }

    return x === y;
  }

  function callback(allEqual, value, key) {
    function compareCurrent(currentEqual, comparer) {
      return currentEqual && compare(comparer[key], value);
    }

    return allEqual && reduce(comparers.slice(1), allEqual, compareCurrent);
  }

  return reduce(comparers[0], true, callback);
}
